import { createFileRoute } from "@tanstack/react-router";
import { CityPicker } from "@/components/CityPicker";
import { SITE_URL } from "@/lib/seo";

export const Route = createFileRoute("/india/silver-cities")({
  head: () => ({
    meta: [
      { title: "Silver Rate by City — India | DrHint" },
      { name: "description", content: "Choose your city to see today's live silver rate in India — Mumbai, Chennai, Bangalore and more." },
      { property: "og:title", content: "Silver Rate by City — India" },
      { property: "og:description", content: "Pick your city and see live silver prices, charts, and full breakdown." },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/india/silver-cities` }],
  }),
  component: () => <CityPicker country="india" metal="silver" />,
});